import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Card, Col, Row, Button, Space, Modal, Checkbox, Tooltip, Switch, Form, Select } from "antd";
import * as yup from "yup";
import { FileDoneOutlined, RedoOutlined, PlusOutlined, MinusCircleOutlined, } from "@ant-design/icons";
import { toast } from "react-toastify";
import PageHeader from "../../view/pageheader";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetSuccessFlag, EventValidatByName } from "../../store/reducer/eventValidationSlice";
import TextInput from "../CustomComponents/TextInput";
import SelectInput from "../CustomComponents/SelectInput";
import { addEvent, addFieldEventStatus, getEventById, updateEvent, getEventFieldStatusById, getEventList } from "../../store/reducer/eventSlice";
import { useSearchParams } from "react-router-dom";
import { getUserGroupList } from "../../store/reducer/userGroupSlice";
import Loader from "../../fields/Loader/Loader";
import TableComponent from "../CustomComponents/TableComponent";

const { Option } = Select;

const AddEditEvents = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { event_id } = useParams();
  const [searchParams] = useSearchParams();
  const copyQuery = searchParams.get("type");
  const [isAddModal, setIsAddModal] = useState(false);
  const [type, setType] = useState("add");
  const [validationOptions, setValidationOptions] = useState([]);
  const [activeFieldIndex, setActiveFieldIndex] = useState(null);
  const [eventData, setEventData] = useState({});
  const [eventDataFields, setEventDataFields] = useState({});
  const [hasStationField, setHasStationField] = useState(false);
  const [otherEventFiled, setOtherEventField] = useState(false)
  const [selectedFieldId, setSelectedFieldId] = useState(null);
  const [eventNames, setEventNames] = useState({});

  const [form] = Form.useForm()
  const [oterEventForm] = Form.useForm()

  const { addEventSuccess, eventListByIdData, updateEventSuccess, addEventError, addEventErrorMessage, eventLoading, addFieldEventStatusSuccess, eventFieldStatusData, eventListData } = useSelector((state) => state.events);
  const {
    userGroupListData,
  } = useSelector((state) => state.userGroups);
  const { data: eventDetailsData } = eventListData
  const [selectedValidationValues, setSelectedValidationValues] = useState({});
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [duplicateIndices, setDuplicateIndices] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [modalInputField, setMOdalInputFields] = useState([{

    operator: "",
    secondvalue: ""
  }])
  const jobId = searchParams.get(("job_id"));


  // const jobId=window.atob(specId)

  // Field Type Options
  const fieldTypeOptions = [
    { value: 1, label: "String" },
    { value: 2, label: "Number" },
    { value: 3, label: "List" },
    { value: 4, label: "Date" },
    { value: 5, label: 'Time' },
    { value: 6, label: 'Calculation' },
    { value: 7, label: 'Date & Time ' },
    // {value:8,label:'Timer'}
    { value: 9, label: 'Time Calculation' },
    { value: 10, label: 'Total Timer Calculation' }
  ];
  const timeOptions = [
    { value: 'hh::mm::ss', label: 'hh::mm::ss' },
    { value: 'hh::mm', label: 'hh::mm' },
  ]
  const dateOptions = [
    { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
    { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' }
  ]
  const passedDateOptions = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' }
  ]
  const dateTimeOptions = [
    { value: 'DD/MM/YYYY hh:mm:ss', label: 'DD/MM/YYYY hh:mm:ss' },
    { value: 'DD/MM/YYYY hh:mm', label: 'DD/MM/YYYY hh:mm' },
    { value: 'MM/DD/YYYY hh:mm:ss', label: 'MM/DD/YYYY hh:mm:ss' },
    { value: 'MM/DD/YYYY hh:mm ', label: 'MM/DD/YYYY hh:mm ' }
  ]
  // Validation schema for the main form
  const validationRules = yup.object().shape({
    eventname: yup.string().trim().required("Event Name is required"),
    fieldvalue: yup.array().of(
      yup.object().shape({
        fieldname: yup.string().trim().required("Field Name is required"),
        fieldtype: yup.number().required("Field Type is required"),
        mandatory: yup.string().notRequired(),
        is_station: yup.number().notRequired(),
      })

    ),
    group_id: yup.number().required("Group is required"),
    status: yup.number().required("Status is required"),
    box_states: yup.number().notRequired("Status is required"),
  });
  function getDataUserGroup(payload = {}) {
    dispatch(getUserGroupList(payload));
    dispatch(getEventList({}))
  }
  useEffect(() => {
    getDataUserGroup();
  }, []);

  const [selectedEventId, setSelectedEventId] = useState(null);
  const [eventFields, setEventFields] = useState([]);

  // Extract events from props
  const events = type == "add" ? eventListData?.data || [] : eventDetailsData.filter((data) => data.id != window.atob(event_id)) || [];

  // When event_id changes, update eventFields dynamically
  useEffect(() => {
    if (selectedEventId) {
      const selectedEvent = events.find(ev => ev.id == selectedEventId);
      setEventFields(selectedEvent?.fields || []);
    } else {
      setEventFields([]);
    }
  }, [selectedEventId, events]);
  useEffect(() => {
    if (addEventSuccess) {
      toast.dismiss();
      toast.success("Event added successfully");
      dispatch(resetSuccessFlag({ flag: "addEventSuccess" }));
      navigate('/events');
    }
    if (updateEventSuccess) {
      toast.dismiss();
      toast.success("Event Updated successfully");
      dispatch(resetSuccessFlag({ flag: "updateEventSuccess" }));
      navigate('/events');

    }
    if (addFieldEventStatusSuccess) {
      // toast.success("Event Stages Updated successfully");
      dispatch(resetSuccessFlag({ flag: "addFieldEventStatusSuccess" }));
      dispatch(getEventFieldStatusById({ id: window.atob(event_id), spec_id: jobId != undefined ? (window.atob(jobId)) : '' }))

    }
    if (addEventError) {
      toast.error(addEventErrorMessage)


    }

  }, [addEventSuccess, updateEventSuccess, addEventError, addEventErrorMessage, addFieldEventStatusSuccess, navigate, dispatch]);


  useEffect(() => {
    if (eventListByIdData) {
      setEventData(eventListByIdData?.event);
    }
    if (eventFieldStatusData) {
      const rawData = eventFieldStatusData?.datas;

      // Optional: safely check if fields exist
      const sortedFields = rawData?.[0]?.fields?.slice().sort((a, b) => a.id - b.id) || [];
      // setEventData(rawData);
      setEventDataFields(sortedFields);
    }
  }, [eventListByIdData, eventFieldStatusData]);


  // Validation schema for the modal form
  const modalValidationRules = yup.object().shape({
    modalFields: yup.array().of(
      yup.object().shape({
        validation: yup.number().notRequired("Validation type is required"),
        validationvalue: yup.string().notRequired("Validation value is required"),
        firstvalue: yup.string().notRequired(),
        operator: yup.string().notRequired(),
        secondvalue: yup.string().notRequired(),
        minvalue: yup.string().notRequired(),
        maxvalue: yup.string().notRequired(),

      })
    )
  });

  // Main form setup
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({
    resolver: yupResolver(validationRules),
    defaultValues: {
      eventname: "",
      fieldvalue: [
        // {
        //   fieldname: "Spec",
        //   fieldtype: fieldTypeOptions[1]?.value,
        // },
        // {
        //   fieldname: "Box",
        //   fieldtype: fieldTypeOptions[1]?.value,
        // },
        // {
        //   fieldname: "Alt Box",
        //   fieldtype: fieldTypeOptions[1]?.value,
        // },
        // {
        //   fieldname: "Barcode",
        //   fieldtype: fieldTypeOptions[1]?.value,

        // },
        // {
        //   fieldname: "Timer",
        //   fieldtype: fieldTypeOptions[4]?.value,

        // }



      ],
      status: 1
    },
  });
  const handleAddExternalField = () => {
    if (!selectedEventId || !selectedFieldId) {
      toast.error("Please select both event and field");
      return;
    }

    // Find the selected event and field
    const selectedEvent = events.find(event => event.id == selectedEventId);
    const selectedField = eventFields.find(field =>
      field.id == selectedFieldId || field.field_id == selectedFieldId
    );

    if (selectedEvent && selectedField) {
      // Store the event name in state
      setEventNames(prev => ({
        ...prev,
        [selectedFieldId]: selectedEvent.eventname
      }));

      // Add the field to your dynamic fields
      appendField({
        fieldname: selectedField.fieldname,
        fieldtype: selectedField.fieldtype,
        mandatory: selectedField.mandatory || 0,
        is_station: selectedField.is_station || 0,
        is_external: true,
        source_event_id: selectedEventId,
        source_field_id: selectedFieldId,
        source_event_name: selectedEvent.eventname // Store event name directly on the field
      });

      oterEventForm.resetFields()

      // Close modal and reset selections
      setOtherEventField(false);
      setSelectedEventId(null);
      setSelectedFieldId(null);
      setEventFields([]);
    }
  };



  useEffect(() => {
    if (copyQuery == "copy" && event_id) {
      const editId = window.atob(event_id); // Decode the event ID
      setType('copy');

      dispatch(getEventById({ id: editId }))
        .unwrap()
        .then((response) => {
          if (response?.event) {
            const event = response.event;
            const userGroupIds = event?.usergroup?.id;
            const fieldLookup = {};
            event.fields.forEach((field) => {
              fieldLookup[field.id] = field.fieldname; // Store fieldname by field_id
            });

            // Map fields from the response to the format expected by the form
            const formattedFields = event?.fields?.map((field) => {
              // Filter validations for the current field based on field_id
              const fieldValidations = event?.fields_validation?.filter(
                (validation) => validation.field_id === field.id
              ).map((validation) => ({
                validation: validation?.validation,
                validationvalue: validation?.validationvalue,
                minvalue: validation?.minvalue,
                maxvalue: validation?.maxvalue,

              }));
              let parsedValidations = [];
              if (field?.fieldtype == 9 && fieldValidations?.length) {
                parsedValidations = fieldValidations.flatMap((validation) => {
                  const parts = validation.validationvalue?.split(","); // Split the values
                  const parsedArray = [];

                  for (let i = 0; i < parts.length; i += 3) {
                    const firstValue = parts[i] || "";
                    const operator = parts[i + 1] || "";
                    const secondValue = parts[i + 2] || "";

                    parsedArray.push({
                      firstvalue: fieldLookup[firstValue] || "Unknown",
                      operator: operator,
                      secondvalue: fieldLookup[secondValue] || "Unknown",
                    });
                  }

                  return parsedArray;
                });
              }
              else if (field?.fieldtype === 6 || field?.fieldtype === 10) {
                parsedValidations = fieldValidations.flatMap((validation) => {
                  const parts = validation.validationvalue?.split(" "); // Split the values
                  const parsedArray = [];

                  // For calculation fields (type 6 and 10), the format is [id1, op1, id2, op2, id3, ...]
                  for (let i = 0; i < parts.length; i += 2) {
                    if (i === 0) {
                      // First operation: id1 op1 id2
                      parsedArray.push({
                        firstvalue: fieldLookup[parts[i]] || parts[i], // Use fieldname if available
                        operator: parts[i + 1] || "",
                        secondvalue: fieldLookup[parts[i + 2]] || parts[i + 2],
                      });
                      i += 1; // Skip the second value since it's used as firstvalue in next step
                    } else {
                      // Subsequent operations: (result) op id
                      parsedArray.push({
                        firstvalue: "", // Empty since it's the result of previous operation
                        operator: parts[i] || "",
                        secondvalue: fieldLookup[parts[i + 1]] || parts[i + 1],
                      });
                    }
                  };
                  return parsedArray;
                });
              }
              return {
                fieldname: field?.fieldname,
                fieldtype: field?.fieldtype,
                mandatory: field?.mandatory,
                is_station: field?.is_station || 0,
                is_external: field?.is_external || false,
                source_event_name: field?.external_event_name,
                field_id: field?.id, // Include field_id to use later for updating validations
                validationvalue: field?.fieldtype == 6 || field?.fieldtype == 9 || field?.fieldtype == 10 ? parsedValidations : fieldValidations,// Include validations for the field
                minvalue: fieldValidations,
                maxvalue: fieldValidations


              };
            });
            reset({
              eventname: "",
              fieldvalue: formattedFields,
              status: event.status || 1,
              box_states: event.box_states,
              group_id: userGroupIds,
            });
          }
        })
        .catch((error) => {

          toast.error("Error fetching event details.");
        });
    }
    else if (copyQuery == "evet_stage") {
      const editId = atob(event_id); // Decode the event ID
      setType('evet_stage');

      dispatch(getEventFieldStatusById({ id: window.atob(event_id), spec_id: jobId != undefined ? (window.atob(jobId)) : '' }))
        .unwrap()
        .then((response) => {
          if (response?.datas) {
            const event = response?.datas[0];
            const userGroupIds = event?.usergroup?.id;
            // const fieldLookup = {};
            // event.fields.forEach((field) => {
            //   fieldLookup[field.id] = field.fieldname; // Store fieldname by field_id
            // });

            // Map fields from the response to the format expected by the form
            // const formattedFields = event?.fields?.map((field) => {
            //   // Filter validations for the current field based on field_id
            //   const fieldValidations = event?.fields_validation?.filter(
            //     (validation) => validation.field_id === field.id
            //   ).map((validation) => ({
            //     validation: validation?.validation,
            //     validationvalue: validation?.validationvalue,
            //     minvalue: validation?.minvalue,
            //     maxvalue: validation?.maxvalue,

            //   }));
            //   let parsedValidations = [];
            //   if (field?.fieldtype == 9 && fieldValidations?.length) {
            //     parsedValidations = fieldValidations.flatMap((validation) => {
            //       const parts = validation.validationvalue?.split(","); // Split the values
            //       const parsedArray = [];

            //       for (let i = 0; i < parts.length; i += 3) {
            //         const firstValue = parts[i] || "";
            //         const operator = parts[i + 1] || "";
            //         const secondValue = parts[i + 2] || "";

            //         parsedArray.push({
            //           firstvalue: fieldLookup[firstValue] || "Unknown",
            //           operator: operator,
            //           secondvalue: fieldLookup[secondValue] || "Unknown",
            //         });
            //       }

            //       return parsedArray;
            //     });
            //   }
            //   else if (field?.fieldtype === 6 || field?.fieldtype === 10) {
            //     parsedValidations = fieldValidations.flatMap((validation) => {
            //       const parts = validation.validationvalue?.split(" "); // Split the values
            //       const parsedArray = [];

            //       // For calculation fields (type 6 and 10), the format is [id1, op1, id2, op2, id3, ...]
            //       for (let i = 0; i < parts.length; i += 2) {
            //         if (i === 0) {
            //           // First operation: id1 op1 id2
            //           parsedArray.push({
            //             firstvalue: fieldLookup[parts[i]] || parts[i], // Use fieldname if available
            //             operator: parts[i + 1] || "",
            //             secondvalue: fieldLookup[parts[i + 2]] || parts[i + 2],
            //           });
            //           i += 1; // Skip the second value since it's used as firstvalue in next step
            //         } else {
            //           // Subsequent operations: (result) op id
            //           parsedArray.push({
            //             firstvalue: "", // Empty since it's the result of previous operation
            //             operator: parts[i] || "",
            //             secondvalue: fieldLookup[parts[i + 1]] || parts[i + 1],
            //           });
            //         }
            //       };
            //       return parsedArray;
            //     });
            //   }
            //   return {
            //     fieldname: field?.fieldname,
            //     fieldtype: field?.fieldtype,
            //     mandatory: field?.mandatory,
            //     field_id: field?.id, // Include field_id to use later for updating validations
            //     validationvalue: field?.fieldtype == 6 || field?.fieldtype == 9 || field?.fieldtype == 10 ? parsedValidations : fieldValidations,// Include validations for the field
            //     minvalue: fieldValidations,
            //     maxvalue: fieldValidations


            //   };
            // });
            reset({
              eventname: event.eventname || "",
              // fieldvalue: formattedFields,
              status: event.status || 1,
              // box_states: event.box_states,
              group_id: userGroupIds,
            });
          }
        })
        .catch((error) => {

          toast.error("Error fetching event details.");
        });
    }
    else if (event_id) {
      const editId = window.atob(event_id);

      setType('edit');

      dispatch(getEventById({ id: editId }))
        .unwrap()
        .then((response) => {
          if (response?.event) {
            const event = response.event;
            const userGroupIds = event?.usergroup?.id;
            const fieldLookup = {};
            event.fields.forEach((field) => {
              fieldLookup[field.id] = field.fieldname; // Store fieldname by field_id
            });

            // Map fields from the response to the format expected by the form
            const formattedFields = event?.fields?.map((field) => {
              // Filter validations for the current field based on field_id
              const fieldValidations = event?.fields_validation?.filter(
                (validation) => validation.field_id === field.id
              ).map((validation) => ({
                validation: validation?.validation,
                validationvalue: validation?.validationvalue,
                minvalue: validation?.minvalue,
                maxvalue: validation?.maxvalue,

              }));


              let parsedValidations = [];
              if (field?.fieldtype == 9 && fieldValidations?.length) {
                parsedValidations = fieldValidations.flatMap((validation) => {
                  const parts = validation.validationvalue?.split(","); // Split the values
                  const parsedArray = [];

                  for (let i = 0; i < parts.length; i += 3) {
                    const firstValue = parts[i] || "";
                    const operator = parts[i + 1] || "";
                    const secondValue = parts[i + 2] || "";

                    parsedArray.push({
                      firstvalue: fieldLookup[firstValue] || "Unknown",
                      operator: operator,
                      secondvalue: fieldLookup[secondValue] || "Unknown",
                    });
                  }

                  return parsedArray;
                });
              }
              else if (field?.fieldtype === 6 || field?.fieldtype === 10) {
                parsedValidations = fieldValidations.flatMap((validation) => {
                  const parts = validation.validationvalue?.split(" "); // Split the values
                  const parsedArray = [];

                  // For calculation fields (type 6 and 10), the format is [id1, op1, id2, op2, id3, ...]
                  for (let i = 0; i < parts.length; i += 2) {
                    if (i === 0) {
                      // First operation: id1 op1 id2
                      parsedArray.push({
                        firstvalue: fieldLookup[parts[i]] || parts[i], // Use fieldname if available
                        operator: parts[i + 1] || "",
                        secondvalue: fieldLookup[parts[i + 2]] || parts[i + 2],
                      });
                      i += 1; // Skip the second value since it's used as firstvalue in next step
                    } else {
                      // Subsequent operations: (result) op id
                      parsedArray.push({
                        firstvalue: "", // Empty since it's the result of previous operation
                        operator: parts[i] || "",
                        secondvalue: fieldLookup[parts[i + 1]] || parts[i + 1],
                      });
                    }
                  }
                  return parsedArray;
                });
              }
              return {
                fieldname: field?.fieldname,
                fieldtype: field?.fieldtype,
                mandatory: field?.mandatory,
                is_station: field?.is_station || 0,
                is_external: field?.is_external || false,
                source_event_name: field?.external_event_name,
                field_id: field?.id, // Include field_id to use later for updating validations
                validationvalue: field?.fieldtype == 6 || field?.fieldtype == 9 || field?.fieldtype == 10 ? parsedValidations : fieldValidations,// Include validations for the field
                minvalue: fieldValidations,
                maxvalue: fieldValidations


              };
            });
            reset({
              eventname: event.eventname || "",
              fieldvalue: formattedFields,
              status: event.status || 1,
              box_states: event.box_states,
              group_id: userGroupIds,
            });
          }
        })


        .catch((error) => {

          // toast.error("Error fetching event details.");
        });
    }


  }, [copyQuery, event_id, dispatch, reset]);

  const watchedFieldValues = useWatch({
    control,
    name: "fieldvalue", // Watch the entire array of dynamic fields
  });
  useEffect(() => {
    const stationExists = watchedFieldValues?.some(field => field.is_station == 1);
    setHasStationField(stationExists);
  }, [watchedFieldValues]);
  useEffect(() => {
    if (activeFieldIndex !== null && watchedFieldValues) {
      const currentFieldType = watchedFieldValues[activeFieldIndex]?.fieldtype;
      if (currentFieldType !== undefined) {
        dispatch(EventValidatByName({ editId: [currentFieldType] }))
          .unwrap()
          .then((response) => {
            if (response) {
              const options = response.map((item) => ({
                label: item?.condition_name,
                value: item?.id,
              }));
              setValidationOptions(options);
            } else {
              // toast.error("Failed to fetch validation options");
            }
          })
          .catch(() => {
            // Handle error appropriately
            // toast.error("Error fetching validation options");
          });
      }
    }
  }, [activeFieldIndex, watchedFieldValues, dispatch]);


  useEffect(() => {
    if (userGroupListData?.data) {
      setUserGroups(userGroupListData?.data);
    }
  }, [userGroupListData]);


  const userGroup = useMemo(() => {
    return userGroups.filter((item) => item?.status === 1).map((item) => ({
      label: item?.user_group_name,
      value: item?.id,
    }));
  }, [userGroups]);

  const isFieldValid = (index) => {
    const field = watchedFieldValues?.[index];
    return field?.fieldname && field?.fieldtype;
  };

  // Function to handle removing an input field

  // Modal form setup
  const modalForm = useForm({
    resolver: yupResolver(modalValidationRules),
    defaultValues: {
      modalFields: [{
        validation: null,
        validationvalue: "",
        firstvalue: "",
        operator: "",
        secondvalue: "",
        minvalue: "",
        maxvalue: ""


      }],
      modalInputField: [{
        validationvalue: "",
        firstvalue: "",
        operator: "",
        secondvalue: "",

      }]
    },
  });

  useEffect(() => {
    const subscription = modalForm.watch((value, { name, type }) => {
      if (name && name.includes('validation') && !name.includes('validationvalue')) {
        const fieldIndex = parseInt(name.match(/\d+/)[0]);


        // Reset the corresponding validation value fields
        modalForm.setValue(`modalFields.${fieldIndex}.validationvalue`, "");
        modalForm.setValue(`modalFields.${fieldIndex}.minvalue`, "");
        modalForm.setValue(`modalFields.${fieldIndex}.maxvalue`, "");

        // Clear any errors related to these fields
        modalForm.clearErrors([
          `modalFields.${fieldIndex}.validationvalue`,
          `modalFields.${fieldIndex}.minvalue`,
          `modalFields.${fieldIndex}.maxvalue`
        ]);
      }
    });

    // return () => subscription.unsubscribe();
  }, [modalForm]);

  // UseFieldArray for modal dynamic fields
  const {
    fields: modalFields,
    append: appendModalField,
    remove: removeModalField
  } = useFieldArray({
    control: modalForm.control,
    name: "modalFields",
  });

  // UseFieldArray for dynamic fields
  const {
    fields: dynamicFields,
    append: appendField,
    remove,
    update: updateField
  } = useFieldArray({
    control,
    name: "fieldvalue",
    keyName: "id",
  });

  const handleAddStation = () => {
    appendField({
      fieldname: 'STATION',
      fieldtype: 3,
      is_station: 1
    });
  };
  // Handle modal submission
  const onModalSubmit = (modalData) => {
    if (activeFieldIndex !== null) {
      const currentField = watchedFieldValues[activeFieldIndex];
      let updatedField = { ...currentField };

      if (currentField.fieldtype === 10 || currentField.fieldtype == 6) {
        // For type 10, flatten the array
        const flatArr = [];
        modalData.modalInputField.forEach((calc, idx) => {
          if (idx == 0) {
            flatArr.push(calc.firstvalue); // id
          }
          flatArr.push(calc.operator);
          flatArr.push(calc.secondvalue); // id
        });
        updatedField.validationvalue = flatArr;
      } else if (currentField.fieldtype == 9) {
        // If you want to keep as array of objects for other types
        updatedField.validationvalue = modalData.modalInputField;
      } else {
        // Other types
        updatedField.validationvalue = modalData.modalFields;
      }

      updateField(activeFieldIndex, updatedField);
      onModalClose();
    }
  };

  const eventStatus = [
    { value: 1, label: "Active" },
    { value: 2, label: "Inactive" }
  ];

  // Open modal for adding validation

  const onModalOpen = (index) => {
    const currentField = dynamicFields[index];
    setActiveFieldIndex(index);
    setSelectedValidationValues({});
    modalForm.clearErrors();

    const hasValidations = currentField.validationvalue && currentField.validationvalue.length > 0;

    // Handle fieldtype 10 or 6 for type "add" (flat array: ["A", "+", "B", "*", "C"])
    if (
      (currentField.fieldtype === 10 || currentField.fieldtype === 6) &&
      hasValidations &&
      type === "add"
    ) {
      const flatArr = currentField.validationvalue;
      const calcSteps = [];

      for (let i = 0; i < flatArr.length - 2; i += 2) {
        calcSteps.push({
          firstvalue: flatArr[i],
          operator: flatArr[i + 1],
          secondvalue: flatArr[i + 2],
        });
      }

      modalForm.reset({
        modalFields: [],
        modalInputField: calcSteps,
      });
    }

    // Handle fieldtype 10 or 6 for type "copy" or "edit" (already structured objects)
    else if (
      (currentField.fieldtype === 10 || currentField.fieldtype === 6) &&
      hasValidations &&
      (type === "copy" || type === "edit")
    ) {
      const calcSteps = currentField.validationvalue.map(item => ({
        firstvalue: item.firstvalue || "",
        operator: item.operator || "",
        secondvalue: item.secondvalue || "",
      }));
      modalForm.reset({
        modalFields: [],
        modalInputField: calcSteps,
      });
    }

    // Handle fieldtype 9 (time calculation type)
    else if (currentField.fieldtype === 9 && hasValidations) {
      modalForm.reset({
        modalFields: [],
        modalInputField: currentField.validationvalue,
      });
    }

    // Handle all other types (standard validations)
    else if (hasValidations) {
      const existingValidations = currentField.validationvalue.map(val => ({
        validation: val.validation,
        validationvalue: val.validationvalue,
        firstvalue: val.firstvalue,
        operator: val.operator,
        secondvalue: val.secondvalue,
        minvalue: val.minvalue,
        maxvalue: val.maxvalue,
      }));

      modalForm.reset({
        modalFields: existingValidations,
        modalInputField: existingValidations,
      });
    }

    // Fallback default when no validations exist
    else {
      modalForm.reset({
        modalFields: [
          {
            validation: null,
            validationvalue: "",
            minvalue: "",
            maxvalue: "",
            operator: "",
            secondvalue: ""
          },
        ],
      });
    }

    setIsAddModal(true);
  };

  // Close modal
  const onModalClose = () => {
    modalForm.reset();
    setMOdalInputFields([{ operator: "", secondvalue: "" }]);
    setIsAddModal(false);
  };
  const addNewInputField = () => {
    setMOdalInputFields([
      ...modalInputField,
      { operator: "", secondvalue: "" }, // Only include operator and secondvalue fields
    ]);
  };

  // Function to remove a specific field
  const removeInputField = (index) => {
    const updatedFields = [...modalInputField];
    updatedFields.splice(index, 1);
    setMOdalInputFields(updatedFields);
  };
  // const handleRemoveField = (index) => {
  //   const updatedFields = [...dynamicFields];
  //   updatedFields.splice(index, 1);
  // }
  const handleValidationValueChange = (index, value, field_type) => {
    setSelectedValidationValues((prev) => ({
      ...prev,
      [index]: field_type,
    }));
  };


  const handleValidationValueChange1 = (index, value, fieldType) => {
    if (fieldType === 3) {
      const duplicates = modalFields.reduce((acc, field, idx) => {
        if (field.validationvalue === value && idx !== index) {
          acc.push(idx); // Add duplicate indices
        }
        return acc;
      }, []);
      setDuplicateIndices(duplicates);
    } else {
      setDuplicateIndices([]); // Clear duplicates for other field types
    }
  };
  const ontoggleChange = (val, fieldId) => {
    const editId = window.atob(jobId);
    const eventId = window.atob(event_id)

    let payload = {
      event_field_id: fieldId,
      is_active: val === true ? 1 : 0,
      event_id: Number(eventId),
      spec_id: Number(editId),
    };
    dispatch(addFieldEventStatus({ postData: payload }))
    dispatch(getEventFieldStatusById({ id: window.atob(event_id), spec_id: jobId != undefined ? (window.atob(jobId)) : '' }))
    toast.dismiss()
    toast.success("Status updated successfully");
  }
  const fieldTypeLabels = {
    1: "String",
    2: "Number",
    3: "List",
    4: "Date",
    5: "Time",
    6: "Calculation",
    7: "Date & Time",
    9: "Time Calculation",
    10: "Total Timer Calculation",
  };
  const boxStates = [{ value: 1, label: 'Awaiting review' },
  { value: 2, label: 'Waiting for production' },
  { value: 3, label: 'To production' },
  { value: 4, label: 'Completed production' },
  { value: 5, label: 'Awaiting destruction' },

  ]
  const columns = [
    {
      title: 'Field Name',
      // dataIndex: 'fieldname',
      key: 'fieldname',
      render: (text, record, index) => (record?.fieldname)
    },
    {
      title: 'Field Type',
      // dataIndex: 'fieldtype',
      key: 'fieldtype',
      render: (text, record) => (
        fieldTypeLabels[record?.fieldtype] || "Unknown"
      ),
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      // render: (text, record) => (
      //   record?.jobevent_fields[0]?.is_active
      // ),
      render: (text, record, index) => (

        <Switch
          // disabled={index < 4}
          defaultValue={1}
          checked={
            !record?.jobevent_fields?.length || record.jobevent_fields[0]?.is_active == 1
          }
          onChange={(data) => ontoggleChange(data, record?.id)}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
        />
      ),
    },

  ];

  const getSecondValueOptions = (index) => {
    const selectedValue = selectedValidationValues[0];
    return CalcdropDown.filter((field) => field.fieldtype === selectedValue);
  };

  const onSubmit = (data) => {
    if (type == "add") {
      dispatch(addEvent({ postData: data }))
    } else if (type == "edit") {

      const editId = atob(event_id)
      dispatch(updateEvent({ postData: data, updateID: editId }))

    } else if (type == "copy") {
      dispatch(addEvent({ postData: data }))

    }
  };
  const handleReset = () => {
    reset();
    modalForm.reset();
  };


  const CalcdropDown = watchedFieldValues?.filter((field) => {
    const currentFieldType = watchedFieldValues[activeFieldIndex]?.fieldtype;

    if (currentFieldType == 9) {
      // For field type 9, only show fields with type 5
      return field.fieldtype == 5;
    } else if (currentFieldType == 10) {
      // For field type 10, only show fields with type 9
      return field.fieldtype === 9;
    } else if (currentFieldType === 6) {
      // For field type 6, show numeric fields (excluding specific types)
      return ![1, 3, 5, 6, 9, 10,].includes(field.fieldtype);
    }
    return false;
  }).map((field) => ({
    label: field.fieldname,
    value: field.fieldname,
    fieldtype: field.fieldtype,
  }));
  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };
  return (
    <>
      <Loader loading={eventLoading} />
      <PageHeader HeaderText="Event Stages" Breadcrumb={[{ name: "Events" }]} backButtonUrl={type === 'evet_stage' ? `/jobs/edit/${jobId}` : undefined} backgroundUrlName={type == 'event_stage' ? false : true} />

      <Card title={type == "edit" ? "Edit Event Stage" : "Add Event Stage"}>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Row justify="end">
            <Col >
              {type !== "evet_stage" && (
                <>
                  <Button className="primary-btn "
                    // disabled={hasStationField}
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setOtherEventField(true)}
                  // style={{ marginTop: "30px" }}
                  // title={hasStationField ? "Station field already exists" : "Add Station"}
                  >
                    Add Other Event Filed
                  </Button>
                  <Button className="primary-btn ml-2"
                    disabled={hasStationField}
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={handleAddStation}
                    // style={{ marginTop: "30px" }}
                    title={hasStationField ? "Station field already exists" : "Add Station"}
                  >
                    Add Station
                  </Button>
                </>
              )}
            </Col>
          </Row>

          <Row gutter={[10, 10]} style={{ marginTop: '20px' }}>


            {/* Event Name Input */}
            <Col span={10} >
              <TextInput
                name="eventname"
                control={control}
                label="Event Stage Name"
                placeholder="Enter your event stage name"
                errors={errors}
                required={true}
                disabled={type == "evet_stage"}
              />
            </Col>
            <Col span={9}>
              <SelectInput
                name="group_id"
                control={control}
                label="Production User Group"
                placeholder="Select user group"
                options={userGroup}
                errors={errors}
                required={true}
                disabled={type == "evet_stage"}
              // mode="multiple" // This enables multi-select
              />
            </Col>
            <Col span={4}>
              <SelectInput
                name="status"
                control={control}
                label="Status"
                placeholder="Select Status"
                options={eventStatus}
                errors={errors}
                required={true}
                disabled={type == "evet_stage"}
              />
            </Col>

            {/* <Col span={12}>
              <SelectInput
                name="box_states"
                control={control}
                label="Box States"
                placeholder="Select Box States"
                options={boxStates}
                errors={errors}
              // required={true}
              />
            </Col> */}

            {type == "evet_stage" ? (
              <>
                <div style={{ marginTop: '20px', width: '1000px' }}>
                  <TableComponent columns={columns}
                    dataSource={eventDataFields}
                  />
                </div>
              </>
            ) : (
              <>
                {dynamicFields.map((field, index) => (
                  <React.Fragment key={field.id}>
                    <Col span={field.is_station == 1 ? 14 : 8}>
                      <TextInput
                        name={`fieldvalue.${index}.fieldname`}
                        control={control}
                        label="Field Name"
                        placeholder="Enter Field Name"
                        errors={errors}
                        disabled={field.is_external}
                        required={true}
                      // disabled={index < 4}

                      />
                      {field.is_external && (
                        <div style={{ fontSize: '12px', color: '#1890ff', marginTop: '4px' }}>
                          (External Field from: {field.source_event_name || eventNames[field.source_field_id] || 'Unknown Event'})
                        </div>
                      )}
                      {errors?.fieldvalue?.[index]?.fieldname && (
                        <p style={{ color: 'red' }} className="error-message">
                          {errors.fieldvalue[index].fieldname.message}
                        </p>
                      )}
                    </Col>

                    {field.is_station !== 1 && (
                      <>
                        <Col span={8}>
                          <SelectInput
                            name={`fieldvalue.${index}.fieldtype`}
                            control={control}
                            label="Field Type"
                            placeholder="Select Field Type"
                            options={fieldTypeOptions}
                            errors={errors}
                            required={true}

                            disabled={field.is_station == 1 || field.is_external}
                          />
                          {errors?.fieldvalue?.[index]?.fieldtype && (
                            <p style={{ color: 'red' }} className="error-message">
                              {errors.fieldvalue[index].fieldtype.message}
                            </p>
                          )}
                        </Col>
                      </>
                    )}
                    {
                      isFieldValid(index) && (
                        <>
                          <Col span={1} style={{ color: 'red' }}>
                            <Controller
                              name={`fieldvalue.${index}.is_station`}
                              control={control}
                              defaultValue={field.is_station || 0}
                              render={({ field }) => (
                                <input type="hidden" {...field} />
                              )}
                            />
                            <Controller
                              name={`fieldvalue.${index}.mandatory`}
                              control={control}
                              defaultValue={0} // Default to 0 (unchecked)
                              render={({ field: { value, onChange } }) => (
                                <Tooltip
                                  title="Mark as Mandatory"
                                  placement="top"
                                >
                                  <Checkbox
                                    style={{ marginTop: "30px" }}
                                    checked={value == 1} // Convert value to boolean
                                    onChange={(e) => onChange(e.target.checked ? 1 : 0)} // Convert boolean to 1/0
                                  >
                                    <span style={{ color: "red", fontSize: '20px' }}>*</span>
                                  </Checkbox>
                                </Tooltip>
                              )}
                            />
                          </Col>
                        </>
                      )
                    }
                    <Col span={3}>
                      {isFieldValid(index) && field.is_station !== 1 && (
                        <Button
                          className="primary-btn ml-2"
                          style={{ marginTop: "25px" }}
                          shape="round"
                          onClick={() => onModalOpen(index)}
                          disabled={field.is_external}
                        >
                          {field.validationvalue && field.validationvalue.length > 0
                            ? "Update Validation"
                            : "Add Validation"}
                        </Button>
                      )}
                    </Col>


                    {dynamicFields.length > 1 && (type == "add" || type == "copy") && (
                      <Col span={field.is_station == 1 ? 4 : 4} style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <Button
                          style={{
                            marginBottom: field.is_external ? '40px' : '25px',
                            marginLeft: field.is_station == 1 ? '40px' : '40px'
                          }}
                          className="bg-danger text-white"
                          type="danger"
                          icon={<MinusCircleOutlined />}
                          onClick={() => remove(index)}

                        >
                          Remove
                        </Button>

                      </Col>
                    )}
                  </React.Fragment>
                ))}
              </>
            )}

          </Row>


          {/* Add Field Button */}
          {
            type !== "evet_stage" && (
              <>
                <Row justify="center" style={{ marginTop: '16px' }}>
                  <Space>
                    <Button
                      type="dashed"
                      icon={<PlusOutlined />}
                      onClick={() => appendField({
                        fieldname: '',
                        fieldtype: null,
                        // validationvalue: [],
                        // mandatory: '',
                        // minvalue: '',
                        // maxvalue: '',

                      })}
                    >
                      Add Field
                    </Button>
                  </Space>
                </Row>
              </>
            )
          }
          {/* Form Action Buttons */}
          <Row justify="center" style={{ marginTop: '17px' }}>
            <Space>
              {type !== "evet_stage" && (
                <Button
                  shape="round"
                  style={{ marginBottom: "30px" }}
                  className="primary-btn"
                  icon={<FileDoneOutlined />}
                  htmlType="submit"
                >
                  {type === "add" || type === "edit" ? "Save" : "Update"}
                </Button>
              )}


              {type === "add" && (
                <Button className="mb-4" onClick={handleReset} icon={<RedoOutlined />}>
                  Reset
                </Button>
              )}
            </Space>
          </Row>
        </form>

        {/* Validation Modal */}
        {
          type !== "evet_stage" && (
            <>
              <Modal
                title="Add Validation"
                className="w-50"
                open={isAddModal} // This should control whether the modal is visible
                onOk={modalForm.handleSubmit(onModalSubmit)} // On submit, handle the form submission
                onCancel={onModalClose} // Close the modal
                width={600}
                okText="Add Validation"
                // Conditionally hide the OK button
                okButtonProps={{
                  style: { display: duplicateIndices.length > 0 ? 'none' : 'inline-block' },
                }}
              >
                <form onSubmit={modalForm.handleSubmit(onModalSubmit)}>
                  {/* Dynamically render input fields */}
                  {modalInputField.map((field, index) => {
                    const fieldType = watchedFieldValues[activeFieldIndex]?.fieldtype;
                    const shouldRender = fieldType == 6 || fieldType == 9 || fieldType == 10;

                    // Get all selected values from all fields except the current one's secondvalue
                    const selectedValues = modalInputField
                      .map((f, i) => {
                        const firstVal = modalForm.getValues(`modalInputField.${i}.firstvalue`);
                        const secondVal = modalForm.getValues(`modalInputField.${i}.secondvalue`);
                        return i === index ? firstVal : [firstVal, secondVal];
                      })
                      .flat()
                      .filter(Boolean); // Remove undefined/null values

                    return (
                      shouldRender && (
                        <Row gutter={16} key={index}>
                          {/* Validation Value Field (only for the first row) */}
                          {index === 0 && (
                            <Col span={6}>
                              <SelectInput
                                name={`modalInputField.${index}.firstvalue`}
                                label={`${getOrdinal(index + 1)} Value`}
                                control={modalForm.control}
                                placeholder="Select Value"
                                options={CalcdropDown}
                                onChange={(value) => {
                                  const selectedField = CalcdropDown.find(
                                    (field) => field.value == value
                                  );
                                  if (selectedField) {
                                    handleValidationValueChange(
                                      index,
                                      value,
                                      selectedField.fieldtype
                                    );
                                  }
                                }}
                                errors={modalForm.formState.errors}
                                required={true}
                              />
                            </Col>
                          )}

                          {/* Operator Field */}
                          <Col span={6}>
                            <SelectInput
                              name={`modalInputField.${index}.operator`}
                              label={"Operations"}
                              control={modalForm.control}
                              placeholder="Select Operator"
                              options={
                                fieldType == 6
                                  ? [
                                    { value: "+", label: "Sum (+)" },
                                    { value: "-", label: "Subtract (-)" },
                                    { value: "*", label: "Multiply (*)" },
                                    { value: "/", label: "Divide (/)" },
                                  ]
                                  : [
                                    { value: "+", label: "Sum (+)" },
                                    { value: "-", label: "Subtract (-)" },
                                  ]
                              }
                              errors={modalForm.formState.errors}
                              required={true}
                            />
                          </Col>

                          {/* Second Value Field */}
                          <Col span={6}>
                            <SelectInput
                              name={`modalInputField.${index}.secondvalue`}
                              control={modalForm.control}
                              label={`${getOrdinal(index + 2)} Value`}
                              placeholder="Select Value"
                              options={CalcdropDown.filter(
                                (opt) =>
                                  !selectedValues.includes(opt.value) &&
                                  (selectedValidationValues[0] ? opt.fieldtype == selectedValidationValues[0] : true)
                              )}
                              errors={modalForm.formState.errors}
                              required={true}
                            />
                          </Col>

                          {/* Remove Button */}
                          {type != "edit" && modalInputField.length > 1 && (
                            <Col span={2} style={{ display: "flex", alignItems: "center" }}>
                              <Button
                                type="danger"
                                icon={<MinusCircleOutlined />}
                                onClick={() => removeInputField(index)}
                              >
                                Remove
                              </Button>
                            </Col>
                          )}
                        </Row>
                      )
                    );
                  })}
                  {(watchedFieldValues[activeFieldIndex]?.fieldtype === 6 || watchedFieldValues[activeFieldIndex]?.fieldtype === 10) && selectedValidationValues[0] !== 4 && selectedValidationValues[0] !== 5 && (
                    <>
                      <Row justify="center" style={{ marginTop: "30px" }}>
                        <Col>
                          <Button
                            type="dashed"
                            icon={<PlusOutlined />}
                            onClick={addNewInputField}
                          >
                            Add Input Field
                          </Button>
                        </Col>
                      </Row>
                    </>
                  )}


                  {/* Dynamic Modal Fields */}
                  {watchedFieldValues[activeFieldIndex]?.fieldtype !== 6 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 9 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 10 && (
                    <>
                      {modalFields.map((field, index) => (
                        <Row key={field.id} gutter={[10, 10]} style={{ marginBottom: '16px' }}>
                          {/* Conditional rendering for fieldtype !== 6 */}
                          <React.Fragment>
                            {watchedFieldValues[activeFieldIndex]?.fieldtype !== 3 && (
                              <Col span={10}>
                                <SelectInput
                                  name={`modalFields.${index}.validation`}
                                  control={modalForm.control}
                                  label="Validation Type"
                                  placeholder="Select Validation"
                                  options={validationOptions}
                                  errors={modalForm.formState.errors}
                                  required
                                />
                              </Col>
                            )}

                            {/* Conditional Rendering for Validation Input */}
                            {(() => {
                              const validation = modalForm.watch(`modalFields.${index}.validation`);
                              if (validation == 13 || validation == 17) {
                                return (
                                  <Col span={10}>
                                    <SelectInput
                                      name={`modalFields.${index}.validationvalue`}
                                      control={modalForm.control}
                                      label="Validation Type"
                                      placeholder="Select Time Format"
                                      options={timeOptions}
                                      errors={modalForm.formState.errors}
                                      required
                                    />
                                  </Col>
                                );
                              } else if (validation === 12) {
                                return (
                                  <Col span={10}>
                                    <SelectInput
                                      name={`modalFields.${index}.validationvalue`}
                                      control={modalForm.control}
                                      label="Validation Type"
                                      placeholder="Select Date Format"
                                      options={passedDateOptions}
                                      errors={modalForm.formState.errors}
                                      required
                                    />
                                  </Col>
                                );
                              } else if (validation === 11) {
                                return (
                                  <Col span={10}>
                                    <SelectInput
                                      name={`modalFields.${index}.validationvalue`}
                                      control={modalForm.control}
                                      label="Validation Type"
                                      placeholder="Select Date Format"
                                      options={dateOptions}
                                      errors={modalForm.formState.errors}
                                      required
                                    />
                                  </Col>
                                );

                              }
                              else if (validation === 16) {
                                return (
                                  <Col span={10}>
                                    <SelectInput
                                      name={`modalFields.${index}.validationvalue`}
                                      control={modalForm.control}
                                      label="Validation Type"
                                      placeholder="Select Date Format"
                                      options={dateTimeOptions}
                                      errors={modalForm.formState.errors}
                                      required
                                    />
                                  </Col>
                                );
                              }
                              else if (validation === 6 || validation === 1) {
                                return (
                                  <>
                                    <Col style={{ marginTop: '-20px', width: '126px' }} >
                                      <TextInput
                                        name={`modalFields.${index}.minvalue`}

                                        control={modalForm.control}
                                        label="Minimum Value"
                                        placeholder="Enter Value"
                                        errors={modalForm.formState.errors}
                                        required
                                      />

                                    </Col>
                                    <Col style={{ marginTop: '-20px', width: '126px' }}  >
                                      <TextInput
                                        name={`modalFields.${index}.maxvalue`}
                                        control={modalForm.control}
                                        label="Maximum Value"
                                        placeholder="Enter Value"
                                        errors={modalForm.formState.errors}
                                        required
                                      />


                                    </Col>
                                  </>
                                );
                              }
                              else if (validation !== 7 && validation !== 8 && validation !== 9 && validation !== 10 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 3) {
                                return (
                                  <Col span={10}>
                                    <TextInput
                                      name={`modalFields.${index}.validationvalue`}
                                      control={modalForm.control}
                                      label="Validation Value"
                                      placeholder="Enter Value"
                                      errors={modalForm.formState.errors}
                                      required
                                    />
                                    {isDuplicate && (
                                      <span style={{ color: 'red', fontSize: '12px' }}>Duplicate value detected</span>
                                    )}
                                  </Col>
                                );
                              }
                              else if (watchedFieldValues[activeFieldIndex]?.fieldtype == 3) {
                                return (
                                  <Col span={10}>
                                    <TextInput
                                      name={`modalFields.${index}.validationvalue`} // Correcting the name syntax
                                      control={modalForm.control}
                                      label="Validation Value"
                                      placeholder="Enter Value"
                                      errors={modalForm.formState.errors}
                                      required
                                      onChange={(e) => handleValidationValueChange1(index, e.target.value, watchedFieldValues[activeFieldIndex]?.fieldtype)}
                                    />
                                    {/* Show duplicate error if isDuplicate is true */}
                                    {duplicateIndices.includes(index) && (
                                      <span style={{ color: 'red', fontSize: '12px' }}>
                                        Duplicate value detected
                                      </span>
                                    )}
                                  </Col>
                                );

                              }
                            })()}
                          </React.Fragment>

                          {/* Remove Field Button */}
                          {modalFields.length > 1 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 6 && (
                            <Col span={4} style={{ display: 'flex', alignItems: 'flex-end' }}>
                              <Button
                                style={{ marginBottom: '25px' }}
                                className="bg-danger text-white"
                                type="danger"
                                icon={<MinusCircleOutlined />}
                                onClick={() => removeModalField(index)}
                              >
                                Remove
                              </Button>
                            </Col>
                          )}
                        </Row>
                      ))}
                    </>
                  )}

                  {/* Add Modal Field Button */}
                  {watchedFieldValues[activeFieldIndex]?.fieldtype !== 6 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 7 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 8 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 9 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 7 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 8 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 10 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 5 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 4 && watchedFieldValues[activeFieldIndex]?.fieldtype !== 7 && (
                    <Row justify="center" style={{ marginTop: '16px' }}>
                      <Space>
                        <Button
                          type="dashed"
                          icon={<PlusOutlined />}
                          onClick={() =>
                            appendModalField({
                              validation: null,
                              validationvalue: '',
                            })
                          }
                        >
                          Add Validation Field
                        </Button>
                      </Space>
                    </Row>
                  )}
                </form>
              </Modal>
            </>
          )
        }
        <Modal
          open={otherEventFiled}
          onCancel={() => {
            setOtherEventField(false);
            setSelectedEventId(null);
            setSelectedFieldId(null);
            setEventFields([]);
          }}
          title="Select Event and Field"
          onOk={handleAddExternalField}
          okText="Add Field"
          okButtonProps={{
            disabled: !selectedEventId || !selectedFieldId
          }}
        >
          <Form layout="vertical" form={oterEventForm}>
            <Form.Item
              label="Event Name"
              name="event_id"
              rules={[{ required: true, message: "Please select an event" }]}
            >
              <Select
                placeholder="Select Event Name"
                value={selectedEventId}
                onChange={value => {
                  setSelectedEventId(value);
                  setSelectedFieldId(null);
                }}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {events.map(event => (
                  <Option key={event.id} value={event.id}>
                    {event.eventname}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Event Field"
              name="event_field_id"
              rules={[{ required: true, message: "Please select an event field" }]}
            >
              <Select
                placeholder={selectedEventId ? "Select Event Field" : "Select Event Name first"}
                value={selectedFieldId}
                onChange={setSelectedFieldId}
                disabled={!selectedEventId}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {eventFields.map(field => (
                  <Option key={field.id} value={field.id}>
                    {field.fieldname} ({fieldTypeLabels[field.fieldtype] || "Unknown"})
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
        {/* Form Submission Button */}

      </Card>
    </>
  );
};
export default AddEditEvents;